import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

export interface PathVersionSurveyDialogData {
  title: string;
  surveyJson: object;
  formReceive: string;
}

@Component({
  selector: 'app-path-version-survey-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, DynamicFormComponent],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="dialog-scroll">
      <app-dynamic-form [dynamicInput]="dynamicInput"></app-dynamic-form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Annuller</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .dialog-scroll {
        max-height: min(70vh, 640px);
        overflow: auto;
        padding-top: 8px;
      }
      h2 {
        margin: 0 0 8px;
        font-size: 1.15rem;
        font-weight: 600;
      }
    `,
  ],
})
export class PathVersionSurveyDialogComponent {
  dynamicInput: Record<string, { type: string; value: unknown }>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PathVersionSurveyDialogData
  ) {
    this.dynamicInput = {
      surveyJSON: {
        type: 'surveyJSON',
        value: JSON.stringify(data.surveyJson),
      },
      formReceiveFunction: { type: 'text', value: data.formReceive },
    };
  }
}
